import { styled } from '@teko/ds-desktop';
import { ProductCarouselWithHeader } from '@teko/teko-ecommerce';
import { ProductCardProps } from '@teko/types/ecommerce';
import { useTenantConfig } from 'contexts';
import { t } from 'i18n';

interface RelatedProductsProps {
  relatedProducts: Array<ProductCardProps>;
}

export const RelatedProducts: React.FC<RelatedProductsProps> = ({
  relatedProducts,
}: RelatedProductsProps) => {
  const { isMobile } = useTenantConfig();

  if (!relatedProducts.length) return null;

  const arrowStyle = {
    backgroundColor: 'white',
    borderRadius: 999,
    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 5px 15px',
  };

  return (
    <HorizontalProductWrapper isMobile={isMobile}>
      <ProductCarouselWithHeader
        header={{
          title: t('Sản phẩm tương tự'),
          style: {
            height: `${isMobile ? '2.75rem' : '2.8rem'}`,
            alignItems: 'flex-end',
          },
        }}
        products={relatedProducts}
        productsPerRow={isMobile ? 2.5 : 6.5}
        dividerColor="divider"
        regionName="relatedProducts"
        style={{ minHeight: 'auto' }}
        customStyleLeftArrow={arrowStyle}
        customStyleRightArrow={arrowStyle}
        desktopProps={{ perSwipe: '', bound: true }}
      />
    </HorizontalProductWrapper>
  );
};

const HorizontalProductWrapper = styled.div<{ isMobile: boolean }>(
  ({ isMobile }) => `
  background: #fff;
  margin-top: 8px;
  border-radius: 16px;

  .wrapper-horizontal-slider {
    padding: 0px 8px;
  }

  .title {
  ${
    isMobile
      ? `font-size: 18px;
    line-height: 24px;`
      : `font-size: 20px;
    line-height: 28px;`
  }
    
    font-weight: 700;
  }
`,
);
